import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as echarts from 'echarts';
import ElementUI from "element-ui";
//element.css
import "element-ui/lib/theme-chalk/index.css";
// reset.css
import "assets/style/reset.css";
import "assets/style/font.scss";
import "assets/iconfont/iconfont.css";
import VueBus from 'vue-bus'
// import directives from 'common/js/directives'
// 日期支持多种格式
import dateFormat from 'common/js/dateFormat'
import "common/js/rem.js";
import message from '@/common/js/message'
import animated from 'animate.css'

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueBus)
Vue.use(animated)

Vue.prototype.$message = message;
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
